import { defineComponent as _defineComponent } from 'vue'
import { translateLang } from '@/data/i18n/translateLang'
import EventBus, { EventBusKey } from '@/util/bus'
import { computed, ref } from 'vue'

import { defaultProcessFiles } from './data'
import { FileType } from './types'
import { isInElement } from './utils'
import { createFile } from './utils/folderFactory'


export default /*#__PURE__*/_defineComponent({
  __name: 'MProcessingFileItem',
  props: {
    file: null,
    usedFileTypes: null
  },
  setup(__props: any) {

const props = __props as {
  file: typeof defaultProcessFiles[number]['files'][number]
  usedFileTypes: FileType[]
}


/** 是否正在拖拽 */
const isDragging = ref(false)
/** 是否进入显示预览元素 */
const isShowDragPreview = ref(false)
/** 拖动预览元素的引用 */
const dragPreviewRef = ref(null)
/** 鼠标位置 */
const mousePosition = ref({ x: 0, y: 0 })
/** 拖动到的目标文件夹名称 */
const targetFolderName = ref('')
/** 拖动跟随的幽灵元素图标*/
const ghostImageRef = ref<HTMLElement>()

const isUsed = computed(() => {
  return props.usedFileTypes.includes(props.file.type)
})

/** 拖动预览元素的位置 */
const dragPreviewElementPosition = computed(() => ({
  left: `${mousePosition.value.x + 10}px`,
  top: `${mousePosition.value.y - 15}px`,
}))

const dragPreviewText = computed(() => {
  return translateLang('将 【{fileName}】 添加到 {folderName}', {
    fileName: props.file.name,
    folderName: targetFolderName.value,
  })
})

/** @description 拖拽开始 初始化数据以及样式 */
function handleDragStart(event: DragEvent) {
  if (!event.dataTransfer) return
  isDragging.value = true
  // 创建一个新的文件
  const file = createFile({
    pid: '',
    name: translateLang(props.file.name),
    type: props.file.type,
    ext: props.file.ext,
  })
  // 设置拖拽数据
  event.dataTransfer.setData('application/json', JSON.stringify({ file }))
  // 设置拖拽效果
  event.dataTransfer.effectAllowed = 'copy'
  // 创建透明的拖拽图像，这样我们可以用自己的跟随元素
  event.dataTransfer.setDragImage(ghostImageRef.value!, 0, 0)
  // 初始化鼠标位置
  mousePosition.value = { x: event.clientX, y: event.clientY }
  controlDragEvent()
  EventBus.$emit(EventBusKey.CUSTOM_FOLDER_DRAG_EVENT, {
    type: 'drag-start',
    file,
  })
}

/** 控制事件监听器 */
function controlDragEvent(isRemove = false) {
  const fn = isRemove ? document.removeEventListener : document.addEventListener
  fn('dragover', handleDragOver)
  fn('dragenter', handleDragEnter)
  fn('dragleave', handleDragLeave)
}

/**
 * @description 拖拽结束只负责动画以及事件监听器的移除，不负责文件夹的操作
 */
function handleDragEnd() {
  isDragging.value = false
  isShowDragPreview.value = false
  controlDragEvent(true)
}

/**
 * @description 拖拽覆盖
 * @param e
 */
function handleDragOver(e: DragEvent) {
  e.preventDefault()
  mousePosition.value = { x: e.clientX, y: e.clientY }
  const target = isInElement(e)
  if (!target) return
  targetFolderName.value = target.dataset.folderName as string
}
/**
 * @description 拖拽进入
 * @param e
 */
function handleDragEnter(e: DragEvent) {
  const target = (e.target as HTMLElement).closest('.folder-item')
  if (target) {
    isShowDragPreview.value = true
  }
}
/**
 * @description 拖拽离开
 * @param e
 */
function handleDragLeave(e: DragEvent) {
  const target = (e.target as HTMLElement).closest('.folder-item')
  if (!target) {
    isShowDragPreview.value = false
  }
}

return { __sfc: true,props, isDragging, isShowDragPreview, dragPreviewRef, mousePosition, targetFolderName, ghostImageRef, isUsed, dragPreviewElementPosition, dragPreviewText, handleDragStart, controlDragEvent, handleDragEnd, handleDragOver, handleDragEnter, handleDragLeave }
}

})